import type { QueuedRequest } from '../types';
import { Icon } from './Icon';
import { RelativeTime } from './RelativeTime';
import { CHANNEL_ICON } from './statusMeta';

export function QueuedRequestRow({ q, n }: { q: QueuedRequest; n: number }) {
  return (
    <div
      style={{
        height: 44,
        background: 'var(--panel-2)',
        borderRadius: 'var(--r-lg)',
        padding: '0 12px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
      }}
    >
      <Icon name={CHANNEL_ICON[q.origin]} size={14} color="var(--faint)" />
      <span className="t-num faint">{n}</span>
      <span className="trunc t-body dim" style={{ flex: 1 }}>
        {q.text}
      </span>
      <RelativeTime at={q.at} />
    </div>
  );
}
